import axios from 'axios'

const errorsHandler = require('@/services/errors')

const module = 'push-admin'

function authHeaders(context) {
    return {
        headers: {
            Authorization: `Bearer ${context.rootGetters['user/getUser'].token}`,
            'Content-Type': 'application/json',
        }
    }
}

const actions = {
    stats: async (context) => {
        return await axios.get(
            `${context.rootGetters['settings/getEndpoint']}api/v1/${module}/stats/`,
            authHeaders(context)
        ).then(result => result.data.result).catch(error => errorsHandler.errorHandler(error))
    },

    subscriptions: async (context, payload = {}) => {
        const params = new URLSearchParams()
        params.append('page', payload.page || 1)
        params.append('limit', payload.limit || 25)
        if (payload.platform) params.append('platform', payload.platform)
        if (payload.segment) params.append('segment', payload.segment)
        if (payload.search) params.append('search', payload.search)

        return await axios.get(
            `${context.rootGetters['settings/getEndpoint']}api/v1/${module}/subscriptions/?${params.toString()}`,
            authHeaders(context)
        ).then(result => result.data.result).catch(error => errorsHandler.errorHandler(error))
    },

    campaigns: async (context, payload = {}) => {
        const params = new URLSearchParams()
        params.append('page', payload.page || 1)
        params.append('limit', payload.limit || 25)
        if (payload.source) params.append('source', payload.source)

        return await axios.get(
            `${context.rootGetters['settings/getEndpoint']}api/v1/${module}/campaigns/?${params.toString()}`,
            authHeaders(context)
        ).then(result => result.data.result).catch(error => errorsHandler.errorHandler(error))
    },

    preview: async (context, payload) => {
        return await axios.post(
            `${context.rootGetters['settings/getEndpoint']}api/v1/${module}/preview/`,
            payload,
            authHeaders(context)
        ).then(result => result.data.result).catch(error => errorsHandler.errorHandler(error))
    },

    send: async (context, payload) => {
        return await axios.post(
            `${context.rootGetters['settings/getEndpoint']}api/v1/${module}/send/`,
            payload,
            authHeaders(context)
        ).then(result => ({
            success: true,
            result: result.data.result
        })).catch(error => errorsHandler.errorHandler(error))
    },

    customerNotifications: async (context, payload = {}) => {
        const params = new URLSearchParams()
        params.append('page', payload.page || 1)
        params.append('limit', payload.limit || 25)
        if (payload.customer_id) params.append('customer_id', payload.customer_id)
        if (payload.type) params.append('type', payload.type)
        if (payload.read != null && payload.read !== '') params.append('read', payload.read)

        return await axios.get(
            `${context.rootGetters['settings/getEndpoint']}api/v1/admin-customer-push-notifications/paginated?${params.toString()}`,
            authHeaders(context)
        ).then(result => result.data).catch(error => errorsHandler.errorHandler(error))
    },
}

export default {
    namespaced: true,
    actions,
}
